import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'
import { Button } from 'react-admin'
import OrderSubscriptionButton from '../users/subscriptions/OrderSubscriptionButton'

const UpgradeDialog = ({open, setOpen, title, content}: {open: boolean, setOpen?: Dispatch<SetStateAction<boolean>>, title: string, content: string}) => {

  const handleClose = () => {
    setOpen && setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions>
        {
          setOpen 
          ? <Button size='medium' onClick={handleClose} label="Schließen" />
          : <Button size='medium' href='./#/' label="Zum Dashboard" />
        }
        <OrderSubscriptionButton size='medium' />
      </DialogActions>
    </Dialog>
  )
}

export default UpgradeDialog